export default __webpack_public_path__ + "static/media/info-circle-inverted.65bfa55a.svg";